// extracted by mini-css-extract-plugin
export default {"app_wrapper":"App_app_wrapper__uCpoi","page_wrapper":"App_page_wrapper__kSGPk"};